import { render, staticRenderFns } from "./OperateTenantMenu.vue?vue&type=template&id=047cf19c"
import script from "./OperateTenantMenu.vue?vue&type=script&lang=js"
export * from "./OperateTenantMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports